export default "__VITE_ASSET__CSnFP4sD__"